module.exports = __webpack_public_path__ + "img/logo.233902c2.png";